import { render, staticRenderFns } from "./TextMessageRecord.vue?vue&type=template&id=12e7341a&scoped=true"
import script from "./TextMessageRecord.vue?vue&type=script&lang=js"
export * from "./TextMessageRecord.vue?vue&type=script&lang=js"
import style0 from "./TextMessageRecord.vue?vue&type=style&index=0&id=12e7341a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e7341a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e7341a')) {
      api.createRecord('12e7341a', component.options)
    } else {
      api.reload('12e7341a', component.options)
    }
    module.hot.accept("./TextMessageRecord.vue?vue&type=template&id=12e7341a&scoped=true", function () {
      api.rerender('12e7341a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messagePush/TextMessageRecord.vue"
export default component.exports